var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileQuestion02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-question-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3332 6.33398V4.53398C13.3332 3.41388 13.3332 2.85383 13.1152 2.426C12.9234 2.04968 12.6175 1.74372 12.2412 1.55197C11.8133 1.33398 11.2533 1.33398 10.1332 1.33398H5.8665C4.7464 1.33398 4.18635 1.33398 3.75852 1.55197C3.3822 1.74372 3.07624 2.04968 2.88449 2.426C2.6665 2.85383 2.6665 3.41388 2.6665 4.53398V11.4673C2.6665 12.5874 2.6665 13.1475 2.88449 13.5753C3.07624 13.9516 3.3822 14.2576 3.75852 14.4493C4.18635 14.6673 4.7464 14.6673 5.8665 14.6673H9.33317M9.33317 7.33398H5.33317M6.6665 10.0007H5.33317M10.6665 4.66732H5.33317M10.9998 10.0021C11.1173 9.66823 11.3492 9.38665 11.6543 9.2073C11.9595 9.02795 12.3183 8.96239 12.6672 9.02223C13.0161 9.08207 13.3325 9.26346 13.5605 9.53425C13.7884 9.80505 13.9132 10.1478 13.9127 10.5018C13.9127 11.501 12.4138 12.0007 12.4138 12.0007M12.4331 14.0007H12.4398",
    stroke: "#424242",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileQuestion02);
export default __webpack_public_path__ + "static/media/file-question-02.1a759f35d8c49980c56b4039496e6e9f.svg";
export { ForwardRef as ReactComponent };